import React from "react";
import { Loading } from "@actinc/dls/components";
import { Backdrop as MuiBackdrop } from "@mui/material";

const Backdrop = ({ loading, open }) => {
  return (
    <MuiBackdrop
      open={!!open || !!loading}
      sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
    >
      {!!loading && (
        <Loading sx={{ zIndex: (theme) => theme.zIndex.drawer + 2 }} />
      )}
    </MuiBackdrop>
  );
};

export { Backdrop };
